import {
    chain,
    PopulateApiParameter as basePopulateApiParameter,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import { createChainHandler, replaceInChain } from "@store/Modules/client-framework/HandlerCreator";

/**
 * Prioritise using "addToChainBefore" or "addToChainAfter" instead of using "replaceInChain" and calling the original function.
 * The "replaceInChain" pattern is used here as an exception to make the changes transparent for implementers.
 */

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    basePopulateApiParameter(props as any);
    props.apiParameter.expand = ["approvers", "roles"];
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);
